<template>
  <div>
    <div class="col-md-12 p-0">
      <div class="container-fluid p-0">
        <ul class="list-unstyled multi-steps m-0">
          <li
            v-for="(item, index) in steps"
            :class="[{'is-active': active == (index)}]">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
    },
    active: {
      type: Number,
    },
  },
}
</script>

<style scoped>
.multi-steps > li.is-active:before, .multi-steps > li.is-active ~ li:before {
  content: counter(stepNum);
  font-family: inherit;
  font-weight: 700;
}
.multi-steps > li.is-active:after, .multi-steps > li.is-active ~ li:after {
  background-color: #ededed;
}
.multi-steps {
  display: table;
  table-layout: fixed;
  width: 100%;
}
.multi-steps > li {
  counter-increment: stepNum;
  text-align: center;
  display: table-cell;
  position: relative;
  color: var(--highlight-color);
  font-size: var(--font-size);
}
.multi-steps > li:before {
  content: "\f00c";
  content: "\2713;";
  content: "\10003";
  content: "\10004";
  content: "\2713";
  display: block;
  margin: 0 auto 4px;
  background-color: var(--tree-color);
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  font-weight: bold;
  border-width: 2px;
  border-style: solid;
  border-color: var(--tree-color);
  border-radius: 50%;
}
.multi-steps > li:after {
  content: "";
  height: 2px;
  width: 100%;
  background-color: var(--tree-color);
  position: absolute;
  top: 16px;
  left: 50%;
  z-index: -1;
}
.multi-steps > li:last-child:after {
  display: none;
}
.multi-steps > li.is-active:before {
  background-color: var(--tree-color);
  border-color: var(--tree-color);
  color: var(--highlight-color);
}
.multi-steps > li.is-active ~ li {
  color: var(--highlight-color);
}
.multi-steps > li.is-active ~ li:before {
  background-color: #ededed;
  border-color: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/StepProgress.vue